<template>
  <div>
      <div class="title"> Snake </div>
      <div class="date"> June 29th, 2018 </div>

      <div class="content">
        
		<p>There was this video (which I did not actually watch lol), titled "Coding Snake in less than 5 minutes", leading me to wonder how fast I could do it. It took me something under an hour and I am pretty satisfied with how it turned out</p>
		
		<div style="position: relative;">
			<div style="display: table; position: relative; margin: 5px auto; font: 15px monospace; color: black;" id="score">Score: 0</div>
			<div id="start">Press space to start</div>
			<canvas style="display: block; margin: 0px auto; height: 500px; width: 500px;" id="game"></canvas>
		</div>

      </div>
  </div>
</template>

<script>

export default {
  name: 'Snake',
  mounted: () => {
      do_js();
  }
}

function do_js() {
var canvas = document.getElementById("game");
var cx = canvas.getContext("2d");

const colorDead = "#3d1c33";
const colorSnake = "#daddd8";
const colorFood = "#ffaae5";
const colorHead = "#9fa09d";

var grid = [];
var gridSize = 25;
var blockBorder = 0.5;
var blockLength = canvas.height / gridSize;
var snakeLength = 2;
var food = undefined;
var snake = undefined;
var direction = 0;
var startScreen = document.getElementById("start");
var score = document.getElementById("score");
var foodEaten = 0;

var keyEvents = []; // key event queue

function newGame() {
	keyEvents.length = 0; // reset any recorded keys from last game
	foodEaten = 0;
	for (let y = 0; y < gridSize; y++) {
		for (let x = 0; x < gridSize; x++) {
			if (!grid[y]) grid[y] = [];
			grid[y][x] = false;
		}
	}
	food = [Math.floor(Math.random() * gridSize), Math.floor(Math.random() * gridSize)]; // y, x
	grid[food[0]][food[1]] = "food";			
	let rand = [Math.floor(Math.random() * (gridSize - 6)) + snakeLength, Math.floor(Math.random() * (gridSize - 4)) + 2]; // y, x
	grid[rand[0]][rand[1]] = "head";
	snake = [rand[0], rand[1]]; // [y1, x1, y2, x2...]
	direction = 0; // of tail; 1 = N, 2 = E...
	if (rand[0] - snakeLength >= 0) {
		direction = 1;
		for (let n = 1; n <= snakeLength; n++) { 
			grid[rand[0] - n][rand[1]] = "snake";
			snake.push(rand[0] - n);
			snake.push(rand[1]);
		}
	}
	else throw new Error("impossible start");
	direction = (direction + 2) % 4; // 180 rotate direction; now the true direction of the head
}

newGame();
		
window.addEventListener("keydown", event => {
	let lastEvent = (keyEvents.length > 0) ? keyEvents[keyEvents.length - 1] : undefined;
	if (event.key == "ArrowUp" && direction != 1 && direction != 3 && lastEvent != 3) keyEvents.push(1);
	else if (event.key == "ArrowRight" && direction != 2 && direction != 4 && lastEvent != 4) keyEvents.push(2);
	else if (event.key == "ArrowDown" && direction != 3 && direction != 1 && lastEvent != 1) keyEvents.push(3);
	else if (event.key == "ArrowLeft" && direction != 4 && direction != 2 && lastEvent != 2) keyEvents.push(4);
	event.preventDefault();
});

function onResize() {
	canvas.width = canvas.offsetHeight;
	canvas.height = canvas.offsetHeight;
	blockLength = canvas.height / gridSize;
	drawGrid();
}
onResize();
window.addEventListener("resize", onResize);

function drawGrid() {
	score.innerHTML = "Score: " + foodEaten;
	cx.clearRect(0, 0, canvas.width, canvas.height);
	for (let y = 0; y < gridSize; y++) {
		for (let x = 0; x < gridSize; x++) {
			if (grid[y][x] == "head") cx.fillStyle = colorHead;
			else if (grid[y][x] == "food") cx.fillStyle = colorFood;
			else if (grid[y][x] == "snake") cx.fillStyle = colorSnake;
			else cx.fillStyle = colorDead;
			cx.fillRect((x * blockLength) + blockBorder, (y * blockLength) + blockBorder, blockLength - (2 * blockBorder), blockLength - (2 * blockBorder));
		}
	}
}
drawGrid();

function game() {
	if (keyEvents.length > 0) direction = keyEvents.shift();
	let snakeHead = [snake[0], snake[1]];
	let lastX = snake.pop(), lastY = snake.pop();
	grid[lastY][lastX] = false;
	grid[snake[0]][snake[1]] = "snake";
	if (direction == 1) {
		snake.unshift(snakeHead[1]);
		snake.unshift(snakeHead[0] - 1);
	}
	else if (direction == 2) {
		snake.unshift(snakeHead[1] + 1);
		snake.unshift(snakeHead[0]);
	}
	else if (direction == 3) {
		snake.unshift(snakeHead[1]);
		snake.unshift(snakeHead[0] + 1);
	}
	else if (direction == 4) {
		snake.unshift(snakeHead[1] - 1);
		snake.unshift(snakeHead[0]);
	}
	if (snake[0] < 0 || snake[0] >= gridSize || snake[1] < 0 || snake[1] >= gridSize || grid[snake[0]][snake[1]] == "snake") {
		console.log("gameover");
		clearInterval(gameClock);
		startScreen.style.display = "table";
		return;
	}
	if (grid[snake[0]][snake[1]] == "food") {
		snake.push(lastY);
		snake.push(lastX);
		grid[lastY][lastX] = "snake";
		food = [Math.floor(Math.random() * gridSize), Math.floor(Math.random() * gridSize)];
		while (grid[food[0]][food[1]])
			food = [Math.floor(Math.random() * gridSize), Math.floor(Math.random() * gridSize)];
		grid[food[0]][food[1]] = "food";
		foodEaten++;
		score.innerHTML = "Score: " + foodEaten;
	}
	grid[snake[0]][snake[1]] = "head";
	drawGrid();
}

var clockSpeed = 100;
var gameClock = null;
window.addEventListener("keyup", event => {
	if (event.key == " ") {
		startScreen.style.display = "none";
		if (!gameClock) {
			gameClock = setInterval(game, clockSpeed);
			return;
		}
		if (gameClock) clearInterval(gameClock);
		newGame();
		gameClock = setInterval(game, clockSpeed);
	}
});

}

</script>

<style scoped>

#start {
    font: 40px monospace; 
    color: black; 
    background: white; 
    border: 5px solid black; 
    border-radius: 5px; 
    padding: 10px; 
    
    display: inline-block; 
    position: absolute; 
    left: 50%; top: 50%; transform: translate(-50%, -50%);
}

</style>
